const Button = require('components/Button/Button');
module.exports = Button;
